import PropertyService from "./propertyService.js";
import { CATEGORIES } from "./consts.js";

// http_build_query は type[]=x を type%5B0%5D=x（= type[0]）と出すため、
// 添字ありの形も添字なしの形も同じ「種別」として拾えるようにしておく
const TYPE_PARAM_PATTERN = /^type(\[\d*\])?$/;

/**
 * 地図検索ページの状態管理クラス
 * DOM参照・フェッチフロー・ローディング制御を一元管理する
 */
class MapStateManager {
    constructor() {
        this.elements = {
            root: document.querySelector(".js-search-map"),
            card: document.querySelector(".js-search-map__card"),
            propertyContainer: document.querySelector(
                ".js-search-map__property-container"
            ),
            loading: document.querySelector(".js-search-map__loading"),
            loadingText: document.querySelector(".pg-search-map__loading-text"),
        };

    }

    /**
     * 物件取得APIのパスセグメントに使う種別を返す。
     *
     * 種別は一覧から引き継いだURLのクエリが持っている。ただしパスセグメントは種別を
     * 1つしか表せないので、2種別以上のときは 'all' のままにして、クエリの type[] 側で
     * サーバーに絞り込ませる（SearchApiTrait::apiMap がクエリを優先して見る）
     */
    getPropertyType() {
        const types = [];
        new URLSearchParams(window.location.search).forEach((value, key) => {
            if (TYPE_PARAM_PATTERN.test(key) && value) types.push(value);
        });

        const unique = [...new Set(types)];
        return unique.length === 1 ? unique[0] : "all";
    }

    // 物件種別から取引種別を判定
    getTransactionType() {
        const type = this.getPropertyType();
        return type === CATEGORIES.INVEST ? "rent" : "buy";
    }

    // ローディング表示
    showLoading() {
        this.elements.loading?.removeAttribute("data-hidden");
    }

    // ローディング非表示
    hideLoading() {
        this.elements.loading?.setAttribute("data-hidden", "");
    }

    // 地図が出せないときはローディングを出したまま理由を差し替える
    showError(message) {
        if (this.elements.loadingText) {
            this.elements.loadingText.textContent = message;
        }
        this.showLoading();
    }

    /**
     * この県の物件をすべて取得する（地図を開いたときの1回だけ）。
     *
     * 失敗しても地図そのものは出したいので、ここで握って空配列を返す
     * （ピンが無いだけの地図になる）。引き継いだ絞り込み条件は PropertyService がクエリごと素通しする
     */
    async fetchProperties() {
        this.showLoading();
        try {
            return await PropertyService.fetchProperties(this.getPropertyType());
        } catch (error) {
            console.error("物件データの取得に失敗しました:", error);
            return [];
        } finally {
            this.hideLoading();
        }
    }
}

export default MapStateManager;
